import React, {useContext} from "react";
import styled from "styled-components";
// @ts-ignore
import {Link} from "react-router-dom";
import {RankingsAndLevelsContext} from "../../../contexts/RankingsAndLevelsContext";
import {CountryProps} from "../../../interfaces/RankingsAndLevelsInterfaces";
import RankingsAndLevelsUtils from "../../../services/RankingsAndLevelsUtils";


const ClickableCountryPath = styled.path`
  fill: ${(props: {tierColor: string}) => props.tierColor};
  fill-opacity: 1;
  stroke: white;
  pointer-events: all;

  &:hover {
    fill: #DCDCDC;
    fill-opacity: 1;
  }
`;

const NonClickableCountryPath = styled.path`
  fill: ${(props: {tierColor: string}) => props.tierColor};
  fill-opacity: 1;
  stroke: white;
`;

const Country: React.FC<CountryProps> = ({country }) => {

    const handleClick = () => ((country.countryInfo && country.countryInfo.country_code) ? `/gip/rankings/map/${country.countryInfo.country_code}` : '/gip/rankings/map' );
    // @ts-ignore
    const {isLife} = useContext(RankingsAndLevelsContext);
    const isClickable = country.countryInfo?.tier;
    if (!!isClickable) {
      return (
        country.path &&
          <Link to={handleClick()}>
              <ClickableCountryPath
                  d={country.path}
                  tierColor={RankingsAndLevelsUtils.handleTierColor(country, isLife)}
                  onClick={handleClick}
              />
          </Link>
      )
    } else {
      return (
        <NonClickableCountryPath
            d={country.path}
            tierColor={RankingsAndLevelsUtils.handleTierColor(country, isLife)}
            onClick={handleClick}
        />
      )
    }
};

export default Country;
